const getDirectoriesRandomFiles =  (dirHandle) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise( async (resolve, reject) => {
    const files = [];
    const directoryNames = [];
    for await (const entry of dirHandle.values()) {
      if (entry.kind === 'directory') {
        if (!/^\d{1,2}_[\w\s-]+/.test(entry.name)) {
          return reject(new Error(`The directory name "${entry.name}" is not in the correct format. Layer directories should be formatted like this: 01_layer-name, 02_layer2...`));
        }

        directoryNames.push(entry.name);
      }
    }
    directoryNames.sort();
    for (const name of directoryNames) {
      for await (const entry of dirHandle.values()) {
        if (entry.kind === 'directory' && entry.name === name) {
          const pictures = [];
          let count = 0;
          for await (const subentry of entry.values()) {
            if (subentry.kind === 'file') {
              const file = await subentry.getFile();
              if (file.type === 'image/png') {
                count++;
                file.parent = entry.name
                pictures.push(file);
              }
            }
          }

          if (count === 0) {
            return reject(new Error(`Warning.  Folder ${name} is empty.   Folders must contain at least one image.  Please fix this issue and try again.`));
          }

          if (pictures.length > 0) {
            const randomIndex = Math.floor(Math.random() * pictures.length);
            files.push(pictures[randomIndex]);
          }
        }
      }
    }

    resolve(files);
  })
}

export default getDirectoriesRandomFiles;
